import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { OnboardingLayout } from '../components/layout/OnboardingLayout'
import CiecConsultationStep from '../components/onboarding/steps/CiecConsultationStep'
import { authService } from '../services/authService'
import { useRepeatFlow } from '../hooks/useRepeatFlow'
import apiClient from '../services/api'

const CiecConsultationPage: React.FC = () => {
  const navigate = useNavigate()
  const [personType, setPersonType] = useState<string | null>(null)
  const [rfc, setRfc] = useState<string>('')
  // 2da solicitud en adelante: sin stepper y la siguiente pantalla depende
  // de consultasStatus.screens.
  const { isRepeat, resolveNextUrl } = useRepeatFlow()

  useEffect(() => {
    const getPersonTypeFromStorage = () => {
      try {
        const userData = localStorage.getItem('user_data')
        console.log('📦 Raw userData from localStorage:', userData)
        if (userData) {
          const user = JSON.parse(userData)
          console.log('👤 Parsed user object:', user)
          console.log('🏷️ PersonType from user:', user.personType)
          return user.personType
        }
        return null
      } catch (error) {
        console.error('Error al obtener personType:', error)
        return null
      }
    }

    const getRfcFromStorage = () => {
      try {
        const userData = localStorage.getItem('user_data')
        console.log('📦 Raw userData from localStorage:', userData)
        if (userData) {
          const user = JSON.parse(userData)
          console.log('👤 Parsed user object:', user)
          console.log('🏷️ RFC from user:', user.rfc)
          return user.rfc
        }
        return null
      } catch (error) {
        console.error('Error al obtener RFC:', error)
        return null
      }
    }

    const personType = getPersonTypeFromStorage()
    const rfc = getRfcFromStorage()
    if (rfc) setRfc(rfc)
    setPersonType(personType)
  }, [])

  let steps = [
    { id: '1', title: '', description: '', status: 'completed' as const },
    { id: '2', title: '', description: '', status: 'completed' as const },
    { id: '3', title: '', description: '', status: 'completed' as const },
    { id: '4', title: '', description: '', status: 'current' as const },
    { id: '5', title: '', description: '', status: 'pending' as const },
    { id: '6', title: '', description: '', status: 'pending' as const },
  ]

  if (personType === 'PFAE') {
    steps = [
      { id: '1', title: '', description: '', status: 'completed' as const },
      { id: '2', title: '', description: '', status: 'completed' as const },
      { id: '3', title: '', description: '', status: 'current' as const },
      { id: '4', title: '', description: '', status: 'pending' as const },
      { id: '5', title: '', description: '', status: 'pending' as const },
    ]
  }

  const handleComplete = async (stepData: any) => {
    console.log('CIEC consultation completed:', stepData)

    // Determinar la siguiente URL basada en el tipo de flujo
    let nextUrl: string
    if (isRepeat) {
      nextUrl = await resolveNextUrl('ciec_consultation')
    } else if (personType === 'PFAE') {
      nextUrl = '/onboarding/documents'
    } else {
      nextUrl = '/onboarding/legal-representative' // For persona_moral
    }

    // Actualizar estatus a 'Rep Legal'
    try {
      const prospectoQuoteId = localStorage.getItem('prospectoQuoteId')
      const token = localStorage.getItem('auth_token')
      if (prospectoQuoteId && token) {
        await apiClient.patch(
          `/cotizador/mis-cotizaciones-prospecto/${prospectoQuoteId}/estatus`,
          { estatus: 'Rep Legal' },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        console.log('✅ Estatus "Rep Legal" actualizado exitosamente')
      } else {
        console.warn(
          '⚠️ prospectoQuoteId o token no encontrado en localStorage'
        )
      }
    } catch (estatusError) {
      console.error('❌ Error actualizando estatus "Rep Legal":', estatusError)
    }

    // Actualizar progressURL en credit-application después del éxito
    try {
      console.log(
        '📍 Updating progressURL after successful CIEC consultation...'
      )
      const creditAppId = await authService.getCurrentCreditApplicationId()

      if (creditAppId) {
        await authService.updateCreditApplicationProgress(creditAppId, nextUrl)
        console.log('✅ ProgressURL updated successfully to:', nextUrl)
      } else {
        console.warn(
          '⚠️ No credit application ID found, skipping progressURL update'
        )
      }
    } catch (progressError) {
      console.error('❌ Error updating progressURL:', progressError)
      // No detener el flujo si falla la actualización del progreso
    }

    // Navigate to next step based on flow type
    navigate(nextUrl)
  }

  return (
    <OnboardingLayout steps={steps} showStepper={!isRepeat}>
      <CiecConsultationStep onComplete={handleComplete} rfc={rfc} />
    </OnboardingLayout>
  )
}

export default CiecConsultationPage
